/* eslint-disable no-lonely-if */
/* eslint-disable prefer-spread */
import { CanvasRendererFactory, CanvasState } from '../canvasrender';
import { CanvasOpMobileMock } from '@fullstory/mobile-flatbuffers';
import { Canvas, CanvasMobileMock } from '../view';
import { MOBILE_MOCK_VALID_METHODS, MOBILE_MOCK_VALID_PROPERTIES } from './security';
import { Matrix } from '../matrix';

export class MobileMockCanvasRendererFactory extends CanvasRendererFactory<CanvasOpMobileMock> {
  visibleForInspectMode(op: Canvas<CanvasOpMobileMock>): boolean {
    return op.op == CanvasOpMobileMock.INVOKE;
  }

  drawsChild(op: Canvas<CanvasOpMobileMock>) {
    switch (op.op) {
      case CanvasOpMobileMock.DRAW_CHILD:
        return op.viewId;
      default:
        return null;
    }
  }

  render(state: CanvasState, op: CanvasMobileMock) {
    const canvas = state.saveStack[0].c2d;
    if (op.op == CanvasOpMobileMock.PROPERTY) {
      // Property assignment
      if (MOBILE_MOCK_VALID_PROPERTIES.indexOf(op.name) != -1) {
        canvas[op.name] = op.p[0];
      }
    } else if (op.op == CanvasOpMobileMock.DRAW_CHILD) {
      // Draw child
      state.drawChild(op.viewId, Matrix.identity());
    } else {
      // Invoke
      if (MOBILE_MOCK_VALID_METHODS.indexOf(op.name) != -1) {
        canvas[op.name].apply(canvas, op.p);
      }
    }
  }
}
